import React, {FunctionComponent} from "react";
import WizardStep from "../../WizardStep";
import statusModell from "../../../../images/Progress/progress_modell.svg";
import UncertainInput from "../../../../commonComponents/UncertainInput";
import {Step} from "../../../WizardMap";
import {ValidatorForm} from "react-material-ui-form-validator";
import {isUncertainInfoEmpty} from "../../../state/utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {setModelValue, toggleModelUnknown} from "../../../state/disposalSlice";
import {NavigationProps} from "../../../slideRouter/navigationHook";

const WizardStepModel: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const dispatch = useDispatch();
    const {currentDisposal: {model}} = useSelector((state: RootState) => state.disposal);

    return (
        <WizardStep
            title={"Um welches Modell handelt es sich?"}
            icon={statusModell}
            backButton={true}
            onBackClick={gotoPrevSlide}
            nextButton={true}
            nextButtonDisabled={isUncertainInfoEmpty(model)}
            onNextClick={() => gotoNextSlide(Step.WATCH_REF)}
        >
            <ValidatorForm onSubmit={() => !isUncertainInfoEmpty(model) && gotoNextSlide(Step.WATCH_REF)}>
                <UncertainInput
                    textInputLabel={"Modell"}
                    textInputValue={model ? model.value : ""}
                    inputDisabled={model && model.unknown}
                    onChangeText={(text: string) => dispatch(setModelValue(text))}
                    checkBoxLabel={"Unbekannt"}
                    checkboxChecked={model && model.unknown}
                    onCheckBoxClick={() => dispatch(toggleModelUnknown())}
                />
            </ValidatorForm>
        </WizardStep>
    );
};

export default WizardStepModel;
